// Rutas de Ingresos e Importar (#1274). Aparte de `config.tsx` porque las usan
// las mismas secciones que `config.tsx` importa (evita el ciclo de imports).

export const INCOME_PATH = "/expenses/income";
export const IMPORT_PATH = "/expenses/import";
/** `?new=ia` en Ingresos: abre «Registrar ingreso» en el modo con IA (`?new=1`: a mano). */
export const INCOME_NEW_PARAM = "new";
export const INCOME_NEW_AI_PATH = `${INCOME_PATH}?${INCOME_NEW_PARAM}=ia`;

/** Modo con que debe abrirse el modal según la URL, o `null` si no lo pide. */
export function incomeDialogFromSearch(search: string): "manual" | "ia" | null {
  const value = new URLSearchParams(search).get(INCOME_NEW_PARAM);
  return value === "ia" ? "ia" : value === "1" ? "manual" : null;
}
